var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('ec-spreadshirt-shop',{attrs:{"shopName":"nordbund","shopUrl":"https://nordbund.myspreadshop.de"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }